/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { ReactElement } from 'react';
import { stateOptions } from '../../../common/utils';
import { CompanyInfo } from '../../../common/types';
import { useAppDispatch } from '../../../common/redux/hooks';
import { setCompanyInfo } from '../../../common/redux/ducks/contractorRegistrationForm';
import { DropDownSelect } from '@motili/ui';

interface StateDropdownProps {
    companyInfo: CompanyInfo;
    addressType: 'billingAddress' | 'companyAddress';
}

export default function StateDropdown({
    companyInfo,
    addressType,
}: StateDropdownProps): ReactElement {
    const dispatch = useAppDispatch();

    const defaultDropDownValue = {
        value: companyInfo[addressType].state,
        label: companyInfo[addressType].state,
    };

    const setBillingAndCompanyStateValue = (value: string) => {
        dispatch(
            setCompanyInfo({
                ...companyInfo,
                companyAddress: {
                    ...companyInfo.companyAddress,
                    state: value,
                },
                billingAddress: {
                    ...companyInfo.billingAddress,
                    state: value,
                },
            })
        );
    };

    const handleStateDropdownChange = (data: any) => {
        if (companyInfo.useCompanyAddressAsBilling) {
            setBillingAndCompanyStateValue(data.value);
        } else {
            dispatch(
                setCompanyInfo({
                    ...companyInfo,
                    [addressType]: {
                        ...companyInfo[addressType],
                        state: data.value,
                    },
                })
            );
        }
    };

    return (
        <DropDownSelect
            name='state'
            defaultValue={
                defaultDropDownValue.value ? defaultDropDownValue : null
            }
            onChange={handleStateDropdownChange}
            placeholder='State'
            options={stateOptions}
        />
    );
}
